export default "__VITE_ASSET__814cc3b1__"